export const route = {
    patterns: {
        cvReimport: '/cv-reimport',
        preview: '/cv-reimport/preview',
        results: '/cv-reimport/results',
    },
};
